import { createSlice } from "@reduxjs/toolkit"
import { Hub, User } from "types/user"
import { destroyCookie, getCookie } from "utils/cookie";
import { fetchFirebaseBackendTokenThunk, fetchUser, login } from "./thunk";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import { Master } from "types";

export interface AuthState {
    loading: boolean,
    error: string | null,
    user: any | null,
    token: string | null,
    isAuthenticated: boolean,
    privileges: string [];
    master: Master | null,
    chatToken: {
        token: string,
        generatedAt: number 
    } | null
}

const initialState: AuthState = {
    user: null,
    loading: false,
    error: null,
    token: getCookie('opsAuthToken'),
    isAuthenticated: !!getCookie('opsAuthToken'),
    privileges: [],
    master: null,
    chatToken: null
}

const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = action.payload;
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            destroyCookie('opsAuthToken');
        },
        resetAuthFlags: (state) => {
            state.error = null
            state.loading = false
        },
        clearChatToken: (state) => {
            state.chatToken = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.error = null;
                state.loading = true
            })
            .addCase(login.fulfilled, (state, action) => {
                state.token = action.payload;
                state.isAuthenticated = true;
                state.error = null;
                state.loading = false;
            })
            .addCase(login.rejected, (state, action) => {
                state.error = action.payload || 'Login Failed!';
                state.loading = false;
            })
            .addCase(fetchUser.pending, (state) => {
                state.error = null;
                state.loading = true
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.user = action.payload.user;
                
                // const hubs = Array.isArray(action.payload.user.hubs) ? action.payload.user.hubs : [];
                // const selectedHubId = state.selectedHubId ? state.selectedHubId :
                //     (hubs.length ? action.payload.user.hubs[0].uuid : null);

                // const selectedHub = hubs.find((hub) => hub.uuid === selectedHubId) ?? (hubs[0] ?? null);
                // state.selectedHub = selectedHub ?? null;
                // state.selectedHubId = selectedHub ? selectedHub.uuid : null;
                state.privileges = action.payload.user.privileges;

                state.master = action.payload.master;

                state.error = null;
                state.loading = false;
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.error = action.payload || 'Failed to fetch user profile!';
                state.loading = false;
            })
             .addCase(fetchFirebaseBackendTokenThunk.fulfilled, (state, {payload}) => {
                state.chatToken = {
                    token: payload.token,
                    generatedAt: Date.now()
                };
            })
    }
});

export const { setError, logout, resetAuthFlags, clearChatToken } = AuthSlice.actions;

export default persistReducer({
    key: 'auth',
    storage,
    whitelist: ['selectedHubId', 'chatToken']
}, AuthSlice.reducer)

